<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="900px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div class="content">
        <el-table :data="tableData.records" border :height="380" style="width: 100%" v-loading="loading">
          <el-table-column prop="folderName" label="文件名" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="uploadType" label="上传类型" show-overflow-tooltip></el-table-column> -->
          <el-table-column prop="uploadDate" label="上传时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="uploadUser" label="上传人" width="100"></el-table-column>
          <el-table-column prop="fileSize" label="大小" width="100"></el-table-column>
        </el-table>
        <div height="auto" style="text-align: right; padding-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  name: "storeClearance",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "手动上传记录";
    },
  },
  data() {
    return {
      loading: false,
      tableData: {},
      imgFormVisible: false,
      addForm: {},
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  methods: {
    init() {
      this.loading = true;
      let data = { 
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.newProduct.productModelBatchUploadRecord({data: data})
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onCancel() {
      this.isVisible = false;
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  // max-height: 60vh;
  // overflow-y: auto;
}

.form-input {
  width: 200px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form .el-form-item {
  margin-bottom: 22px;
}
</style>
